<div class="layout-container-grid">
  <div class="header"><app-header></app-header></div>
  <div class="content"><router-outlet class="main-container"></router-outlet></div>
  <div class="footer"><app-footer></app-footer></div>
</div>
